import { pxToRem } from './px-to-rem'

export { pxToRem } from './px-to-rem'

const baseColor = {
  '--color-text-tertiary': '#b2b2b2',
}

const baseFontWeight = {
  '--fw-400': '400',
  '--fw-500': '500',
  '--fw-600': '600',
  '--fw-700': '700',
  '--fw-800': '800',
  '--fw-900': '900',
}

const baseFontFamily = {
  '--string-font': 'Roboto-Regular',
  '--number-font': 'Inter-Regular',
}

const baseFontSize = {
  '--fs-10': pxToRem(10),
  '--fs-11': pxToRem(11),
  '--fs-12': pxToRem(12),
  '--fs-14': pxToRem(14),
  '--fs-16': pxToRem(16),
  '--fs-20': pxToRem(20),
  '--fs-24': pxToRem(24),
  '--fs-28': pxToRem(28),
  '--fs-32': pxToRem(32),
  '--fs-40': pxToRem(40),
  '--fs-48': pxToRem(48),
}

const baseLineHeight = {
  '--lh-display-58': pxToRem(58),
  '--lh-display-48': pxToRem(48),
  '--lh-display-40': pxToRem(40),
  '--lh-headline-36': pxToRem(36),
  '--lh-headline-32': pxToRem(32),
  '--lh-headline-28': pxToRem(28),
  '--lh-title-28': pxToRem(28),
  '--lh-title-24': pxToRem(24),
  '--lh-title-20': pxToRem(20),
  '--lh-body-24': pxToRem(24),
  '--lh-body-20': pxToRem(20),
  '--lh-body-18': pxToRem(18),
  '--lh-label-18': pxToRem(18),
  '--lh-label-16': pxToRem(16),
  '--lh-label-14': pxToRem(14),
}

const arFontFamily = {
  '--string-font': 'NotoSans-Arabic',
  '--number-font': 'Inter-Regular',
}

const arFontSize = {
  '--fs-10': pxToRem(10 + 2),
  '--fs-11': pxToRem(11 + 2),
  '--fs-12': pxToRem(12 + 2),
  '--fs-14': pxToRem(14 + 2),
  '--fs-16': pxToRem(16 + 2),
  '--fs-20': pxToRem(20 + 0),
  '--fs-24': pxToRem(24 + 0),
  '--fs-28': pxToRem(28 + 0),
  '--fs-32': pxToRem(32 + 0),
  '--fs-40': pxToRem(40 + 0),
  '--fs-48': pxToRem(48 + 0),
}

const arLineHeight = {
  '--lh-display-58': pxToRem(58 + 4),
  '--lh-display-48': pxToRem(48 + 4),
  '--lh-display-40': pxToRem(40 + 4),
  '--lh-headline-36': pxToRem(36 + 4),
  '--lh-headline-32': pxToRem(32 + 4),
  '--lh-headline-28': pxToRem(28 + 0),
  '--lh-title-28': pxToRem(28 + 0),
  '--lh-title-24': pxToRem(24 + 2),
  '--lh-title-20': pxToRem(20 + 4),
  '--lh-body-24': pxToRem(24 + 2),
  '--lh-body-20': pxToRem(20 + 4),
  '--lh-body-18': pxToRem(18 + 2),
  '--lh-label-18': pxToRem(18 + 6),
  '--lh-label-16': pxToRem(16 + 4),
  '--lh-label-14': pxToRem(14 + 2),
}

export const getBaseFeature = (lang) => {
  const currentLang = lang != null ? lang : window.lang
  // 阿语
  if (currentLang === 'ar') {
    return {
      ...baseColor,
      ...baseFontWeight,
      ...arFontFamily,
      ...arFontSize,
      ...arLineHeight,
    }
  }
  // 其他
  else {
    return {
      ...baseColor,
      ...baseFontWeight,
      ...baseFontFamily,
      ...baseFontSize,
      ...baseLineHeight,
    }
  }
}

/** 将基础字体/字号变量挂到 html，供 teleport 到 body 的组件（如 van-picker）使用 */
export function applyHtmlBaseCssVars(lang) {
  const vars = getBaseFeature(lang)
  const html = document.documentElement
  Object.entries(vars).forEach(([key, value]) => {
    html.style.setProperty(key, value)
  })
}

export default {
  pxToRem,
  getBaseFeature,
  applyHtmlBaseCssVars,
}
